<template>
    <ClientLayout>
        <v-card flat>
            <v-card-text>
                <v-form @submit.prevent="submit">
                    <ResponsiveImage :src="require('@/assets/logo.png')" alt="LS Logo"></ResponsiveImage>
                    <p class="display-1 text-xs-center">LifeSkills</p>
                    <div class="primary--text text-xs-center" v-if="forgot">Enter your email address</div>
                    <v-text-field
                        outline
                        single-line
                        prepend-inner-icon="email"
                        v-model.trim="email"
                        label="Email"
                        type="email"
                        v-if="!resetToken"
                    ></v-text-field>
                    <div class="primary--text text-xs-center" v-if="resetToken">Enter your new password</div>
                    <v-text-field
                        outline
                        single-line
                        prepend-inner-icon="lock"
                        v-model="password"
                        label="Password"
                        type="password"
                        v-if="!forgot"
                    ></v-text-field>
                    <div class="error--text empty-height">{{ error }}</div>
                    <div class="text-xs-center mt-3">
                        <v-btn round large color="primary" type="submit" :disabled="!canSubmit">{{ resetToken || forgot ? 'Submit' : 'Log In' }}</v-btn>
                    </div>
                    <div class="text-xs-center mt-3" v-if="!resetToken && !forgot">
                        <a href @click.prevent="forgotPassword()">Forgot password?</a>
                    </div>
                </v-form>
            </v-card-text>
        </v-card>
    </ClientLayout>
</template>

<script>
import { trim } from 'lodash';

export default {
    name: 'Login',
    data() {
        return {
            resetToken: null,
            forgot: false,
            error: '',
            email: '',
            password: ''
        };
    },
    computed: {
        canSubmit() {
            if (this.resetToken) {
                return this.password;
            } else if (this.forgot) {
                return this.email;
            }
            return this.email && this.password;
        }
    },
    mounted() {
        if (this.$route.query.forgot) {
            this.resetToken = this.$route.query.forgot;
        } else if (this.$route.query.register) {
            this.resetToken = this.$route.query.register;
        }
    },
    methods: {
        forgotPassword() {
            this.error = '';
            this.forgot = true;
        },
        submit() {
            this.error = '';

            if (this.resetToken) {
                if (trim(this.password || '').length < 8) {
                    this.error = 'Password must be at least 8 characters long';
                    this.password = '';
                    setTimeout(() => {
                        this.error = '';
                    }, 4000);
                    return;
                }
                this.$api
                    .post(`/forgot/${this.resetToken}`, { password: this.password })
                    .then(response => {
                        this.resetToken = null;
                        this.email = response.data.email || '';
                        this.password = '';
                        this.error = 'Your password has been updated, please log in with your email and new password';
                        setTimeout(() => {
                            this.error = '';
                        }, 4000);
                    })
                    .catch(() => {
                        this.error = 'Unable to update password, your link may have expired';
                        this.password = '';
                        setTimeout(() => {
                            window.location.replace('/');
                        }, 4000);
                    });
            } else if (this.forgot) {
                this.$api
                    .post('/forgot', { email: this.email })
                    .then(() => {
                        this.email = '';
                        this.password = '';
                        this.error = 'If you have a valid LifeSkills account, you will receive a password reset link via email';
                        setTimeout(() => {
                            this.forgot = false;
                            this.error = '';
                        }, 4000);
                    })
                    .catch(() => {
                        this.email = '';
                        this.password = '';
                        this.error = 'Unable to request password reset';
                        setTimeout(() => {
                            this.forgot = false;
                            this.error = '';
                        }, 4000);
                    });
            } else {
                this.$api
                    .post('/login', { email: this.email, password: this.password })
                    .then(() => {
                        window.location.replace('/');
                    })
                    .catch(error => {
                        this.error = error.response.data;
                    });
            }
        }
    }
};
</script>
